import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from './tableComponent';
import Sublogin from './elements/sublogin';
import config from '../config';
import { getSid, getItem } from 'src/helpers/session';

class Component extends TableComponent {
  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day'),
    type: 'cupid',
    only_sales: true,
    expand: true,
    affType: 'affiliates'
  };

  getInitialState = (initialState) => {
    if (this.props.user.role_id >= 3) {
      initialState.expand = false;
      initialState.only_sales = true;
      // initialState.from = moment().subtract(1, 'month')
      initialState.from = moment().isoWeekday(1);
    } else {
      initialState.expand = true;
      initialState.only_sales = false;
      initialState.from = moment().isoWeekday(1);
    }
    return initialState;
  };

  makeColumns = () => {
    var columns;
    var expand = this.props.state.expand || this.props.state.initial;
    if (this.props.state.initial && this.props.user.role_id >= 3) {
      expand = false;
    }
    let hookupbay = this.props.state.type == 'hookupbay';
    let total = this.props.total;
    let scale = getItem('statsScale') || 1;
    console.log('state', this.state, this.props.state);
    if (expand) {
      columns = [
        {
          Header: 'Wid',
          accessor: 'aid',
          minWidth: 50,
          Footer: (props) => <span>Total</span>
        },
        {
          Header: (props) => 'Name / Reg date',
          accessor: 'name',
          minWidth: 150,
          Cell: (props) => (
            <div>
              {props.value} <br /> {moment(props.original.date * 1000).format('D MMM YYYY')}
            </div>
          ),
          Footer: (props) => <span>{this.props.total.count || 0}</span>
        },
        {
          Header: (props) => 'Email / Skype',
          accessor: 'email',
          minWidth: 180,
          Cell: (props) => (
            <div>
              {props.value} <br />{' '}
              {props.original.skype != props.original.email ? props.original.skype : ''}
            </div>
          )
        },
        {
          Header: 'Today',
          accessor: 'today_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              <div>
                <span>{props.original.today_sales * scale || 0} sales</span> /
                {hookupbay && <span> {props.original.today_refunds * scale || 0} ref / </span>}
                <span> $ {props.original.today_dollars * scale || 0}</span>
              </div>
              <div>
                {props.original.today_visits * scale || 0} visits /{' '}
                {props.original.today_unique * scale || 0} uniq
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>$ {this.props.total.today_dollars * scale || 0}</div>
              <div>{this.props.total.today_sales * scale || 0} sales</div>
              <div>{this.props.total.today_visits * scale || 0} visits</div>
              <div>{this.props.total.today_unique * scale || 0} unique</div>
              {hookupbay && <div>{this.props.total.today_refunds * scale || 0} refunds</div>}
            </div>
          )
        },
        {
          Header: 'Yesterday',
          accessor: 'yesterday_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              <div>
                <span>{props.original.yesterday_sales * scale || 0} sales</span> /
                {hookupbay && <span> {props.original.yesterday_refunds * scale || 0} ref / </span>}
                <span> $ {props.original.yesterday_dollars * scale || 0}</span>
              </div>
              <div>
                {props.original.yesterday_visits * scale || 0} visits /{' '}
                {props.original.yesterday_unique * scale || 0} uniq
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>$ {this.props.total.yesterday_dollars * scale || 0}</div>
              <div>{this.props.total.yesterday_sales * scale || 0} sales</div>
              <div>{this.props.total.yesterday_visits * scale || 0} visits</div>
              <div>{this.props.total.yesterday_unique * scale || 0} unique</div>
              {hookupbay && <div>{this.props.total.yesterday_refunds * scale || 0} refunds</div>}
            </div>
          )
        },
        {
          Header: 'Last week',
          accessor: 'week_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              <div>
                <span>{props.original.week_sales * scale || 0} sales</span> /
                {hookupbay && <span> {props.original.week_refunds * scale || 0} ref / </span>}
                <span> $ {props.original.week_dollars * scale || 0}</span>
              </div>
              <div>
                {props.original.week_visits * scale || 0} visits /{' '}
                {props.original.week_unique * scale || 0} uniq
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>$ {this.props.total.week_dollars * scale || 0}</div>
              <div>{this.props.total.week_sales * scale || 0} sales</div>
              <div>{this.props.total.week_visits * scale || 0} visits</div>
              <div>{this.props.total.week_unique * scale || 0} unique</div>
              {hookupbay && <div>{this.props.total.week_refunds * scale || 0} refunds</div>}
            </div>
          )
        },
        {
          Header: (props) =>
            this.props.state.from.format('D MMM') + ' - ' + this.props.state.to.format('D MMM'),
          accessor: 'between_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              <div>
                <span>{props.original.between_sales * scale || 0} sales</span> /
                {hookupbay && <span> {props.original.between_refunds * scale || 0} ref / </span>}
                <span> $ {props.original.between_dollars * scale || 0}</span>
              </div>
              <div>
                {props.original.between_visits * scale || 0} visits /{' '}
                {props.original.between_unique * scale || 0} uniq
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>$ {this.props.total.between_dollars * scale || 0}</div>
              <div>{this.props.total.between_sales * scale || 0} sales</div>
              <div>{this.props.total.between_visits * scale || 0} visits</div>
              <div>{this.props.total.between_unique * scale || 0} unique</div>
              {hookupbay && <div>{this.props.total.between_refunds * scale || 0} refunds</div>}
            </div>
          )
        }
      ];
    } else {
      columns = [
        {
          Header: 'Wid',
          accessor: 'aid',
          minWidth: 50,
          Footer: (props) => <span>Total</span>
        },
        {
          Header: (props) => 'Name',
          accessor: 'name',
          minWidth: 150,
          Cell: (props) => <div>{props.value}</div>,
          Footer: (props) => <span>{this.props.total.count || 0}</span>
        },
        {
          Header: (props) => 'Email ',
          accessor: 'email',
          minWidth: 180
        },
        {
          Header: 'Today',
          accessor: 'today_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              <span>{props.original.today_sales * scale || 0} sales</span> /
              {hookupbay && <span> {props.original.today_refunds * scale || 0} ref / </span>}
              <span> $ {props.original.today_dollars * scale || 0}</span>
            </div>
          ),
          // Footer: props => <div>{this.props.total.today_sales || 0} sales <br /> $ {this.props.total.today_dollars || 0}</div>
          Footer: (props) => (
            <div>
              <div>{this.props.total.today_sales * scale || 0} sales</div>
              {hookupbay && <div>{this.props.total.today_refunds * scale || 0} refunds</div>}
              <div>$ {this.props.total.today_dollars * scale || 0}</div>
            </div>
          )
        },
        {
          Header: 'Yesterday',
          accessor: 'yesterday_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              <span>{props.original.yesterday_sales * scale || 0} sales</span> /
              {hookupbay && <span> {props.original.yesterday_refunds * scale || 0} ref / </span>}
              <span> $ {props.original.yesterday_dollars * scale || 0}</span>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>{this.props.total.yesterday_sales * scale || 0} sales</div>
              {hookupbay && <div>{this.props.total.yesterday_refunds * scale || 0} refunds</div>}
              <div>$ {this.props.total.yesterday_dollars * scale || 0}</div>
            </div>
          )
        },
        {
          Header: 'Last week',
          accessor: 'week_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              <span>{props.original.week_sales * scale || 0} sales</span> /
              {hookupbay && <span> {props.original.week_refunds * scale || 0} ref / </span>}
              <span> $ {props.original.week_dollars * scale || 0}</span>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>{this.props.total.week_sales * scale || 0} sales</div>
              {hookupbay && <div>{this.props.total.week_refunds * scale || 0} refunds</div>}
              <div>$ {this.props.total.week_dollars * scale || 0}</div>
            </div>
          )
        },
        {
          Header: (props) =>
            this.props.state.from.format('D MMM') + ' - ' + this.props.state.to.format('D MMM'),
          accessor: 'between_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              <span>{props.original.between_sales * scale || 0} sales</span> /
              {hookupbay && <span> {props.original.between_refunds * scale || 0} ref / </span>}
              <span> $ {props.original.between_dollars * scale || 0}</span>
            </div>
          ),
          Footer: (props) => (
            <div>
              <div>{this.props.total.between_sales * scale || 0} sales</div>
              {hookupbay && <div>{this.props.total.between_refunds * scale || 0} refunds</div>}
              <div>$ {this.props.total.between_dollars * scale || 0}</div>
            </div>
          )
        }
      ];
    }

    if (this.props.user.role_id >= 3 && !expand && false) {
      columns.push({
        Header: '',
        accessor: 'aid',
        id: 'pay',
        sortable: false,
        minWidth: 80,
        Cell: (props) => <button class='btn btn-sm primary'>Pay</button>
      });
    } else {
      columns.push({
        Header: '',
        accessor: 'aid',
        id: 'pay',
        sortable: false,
        minWidth: 70,
        Cell: (props) => (
          <div>
            <div>
              <Sublogin aid={props.value} class='p-0' />
            </div>
            {expand && (
              <div>
                <Link
                  class='btn btn-sm btn-block warning mt-1 p-0'
                  to={config.basePath + '/affiliate/' + props.value + '/sales'}
                >
                  Sales
                </Link>
              </div>
            )}
          </div>
        )
      });
    }
    return columns;
  };

  apiPath = 'master/stats';

  tableParams = {
    manual: true,
    sorted: [
      {
        id: 'week_dollars',
        desc: true
      }
    ],
    showAll: false
  };
  fetchParams = (state) => {
    return {
      only_sales: this.props.state.only_sales,
      load_all: this.props.state.only_sales,
      affType: this.props.state.affType || 'affiliates'
    };
  };

  typeOptions = [
    { name: 'All links', value: 'all' },
    { name: 'HLinks', value: 'chatsales' },
    { name: 'ALinks', value: 'andy' },
    { name: 'CPS', value: 'andy1' },
    { name: 'A3', value: 'andy30' },
    { name: 'A6', value: 'andy60' },
    { name: 'KLinks', value: 'chris' },
    { name: 'EasySX', value: 'danny' },
    { name: 'C.link.old', value: 'chris2' },
    { name: 'IFramecash', value: 'sexplaycam' },
    { name: 'Livecam', value: 'imlive' },
    { name: 'CeVIP', value: 'cevip' },
    { name: 'Wellhello', value: 'wellhello' },
    { name: 'Higher', value: 'hgh2' },
    { name: 'H1', value: 'hg1' },
    { name: 'HBay', value: 'hookupbay' },
    { name: 'DGold', value: 'dgold' },
    { name: 'PunkBank', value: 'punk' },
    { name: 'PunkBank1', value: 'punk1' },
    { name: 'SLinks', value: 'sms' },
    { name: 'Cupid', value: 'cupid' },
    { name: 'Loc', value: 'loc' }
  ];

  render() {
    this.tableParams.showAll = this.props.state.only_sales;
    return (
      <div class='co__pg-all-stats'>
        {!this.props.state.initial && (
          <div>
            {this.props.user.role_id >= 4 && (
              <div class='row table-head-controls mb-2 co__table-filters'>
                <div class='col-sm'>
                  {this.props.user.role_id >= 3 && (
                    <div class='btn-group'>
                      {this.typeButton('Admins', 'admins', '', null, 'affType')}
                      {this.typeButton('Masters', 'masters', '', null, 'affType')}
                      {this.typeButton('Affiliates', 'affiliates', '', null, 'affType')}
                      {this.typeButton('Agents', 'agents', '', null, 'affType')}
                      {false && this.typeButton('Banned', 'banned', '', null, 'affType')}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div class='row table-head-controls'>
              <div class='col-10'>
                {this.datepickerElement()}
                {this.props.user.role_id >= 2 && (
                  <div class='d-inline-block ml-2'>
                    <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                      <input
                        type='checkbox'
                        name='only_sales'
                        checked={this.props.state.only_sales}
                        onChange={this.changeType}
                      />
                      <i></i>
                    </label>
                    <span class='ml-1 switch-description'>Active affiliates</span>
                  </div>
                )}
                <a
                  href={
                    '/app/api/master/stats_export?sid=' +
                    getSid() +
                    '&only_sales=' +
                    Number(this.props.state.only_sales) +
                    '&from=' +
                    this.props.state.from.format('DD-MM-YYYY') +
                    '&to=' +
                    this.props.state.to.format('DD-MM-YYYY')
                  }
                >
                  <button class='btn btn-sm primary ml-2'>CSV</button>
                </a>
                <div class='d-inline-block ml-2'>
                  <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                    <input
                      type='checkbox'
                      name='expand'
                      checked={this.props.state.expand}
                      onChange={(e) => this.changeType(e, true)}
                    />
                    <i></i>
                  </label>
                  <span class='ml-1 switch-description'>Expand</span>
                </div>
                {this.props.user.role_id >= 3 && (
                  <select
                    class='form-control form-control-sm table-select mr-4 pull-right'
                    onChange={this.changeType}
                    name='type'
                  >
                    {this.typeOptions.map((offer) => (
                      <option key={offer.value} value={offer.value}>
                        {offer.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div class='col-2'>{this.searchElement()}</div>
            </div>
          </div>
        )}
        <div class='row'>
          <div class='col-sm-12'>
            <div class='box mt-2'>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'master_stats');
